// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H13.3276C12.1768 22.0565 11.498 20.6405 11.498 19.1336V11.5H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.498 13.5H22.498V19.1336C22.498 20.1466 21.9868 21.0912 21.1388 21.6452L17.998 23.6969L14.8573 21.6452C14.0093 21.0912 13.498 20.1466 13.498 19.1336V13.5Z"}}]};

const FileSafetyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-safety-filled',
    ref,
    icon: element,
  },
));

FileSafetyFilledIcon.displayName = 'FileSafetyFilledIcon';

export default FileSafetyFilledIcon;
